<template>
	<div class="login-container">
		<div style="position: absolute;top: -100%;left: -100%;">
			<input type="text" autocomplete="off">
			<input type="password" autocomplete="new-password">
			<input type="text" autocomplete="off">
		</div>
		<div class="login-container-bg">
			<div class="login-content">
				<login-header></login-header>
				<div class="login-box popup-container">
					<div class="register-box-item-title box flex-justify-between">
						<p class="register-box-title color-primary">用户注册</p>
						<p class="text-secondary">已有账号？<span class="color-primary cursor-pointer" @click="skip('/login')">马上登录<i class="icon icon-next"></i></span></p>
					</div>
					<div class="popup-info-container">
						<div class="account-info-module account-new-module">
							<div class="popup-item">
								<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.email"
												:trigger="errorMsg.email ? 'show' : 'hide'" type="danger"
												position="absolute" top="-1px" left="400px"
												placement="right">
									<div class="box">
									<span class="box flex-center color-danger font-default pad-lr-xs">*</span>
										<efly-input size="default" type="text" width="100%" prefix-icon="icon-email" placeholder="电子邮箱"
													v-model="status.email" @blur="checkInput('email')"></efly-input>
									</div>
								</efly-tooltip>
							</div>
							<div class="popup-item">
								<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;"
												:trigger="errorMsg.password ? 'show' : 'hide'" type="danger"
												position="absolute" :top="errorMsg.password.length > 19 ? '-5px' : '-1px'" left="400px"
												placement="right">
									<div slot="content">
										<p class="break-wrod">{{errorMsg.password.slice(0, 19)}}</p>
										<p class="break-wrod" v-if="errorMsg.password.length > 19">{{errorMsg.password.slice(19)}}</p>
									</div>
									<div class="box">
										<span class="box flex-center color-danger font-default pad-lr-xs">*</span>
										<efly-input size="default" type="password" width="100%" prefix-icon="icon-lock" placeholder="密码(8~32字符,至少含数字/字母/特殊字符中的2种)"
													v-model="status.password" @blur="checkInput('password')"></efly-input>
									</div>
								</efly-tooltip>
							</div>
							<div class="popup-item">
								<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.confirmPassword"
												:trigger="errorMsg.confirmPassword ? 'show' : 'hide'" type="danger"
												position="absolute" top="-1px" left="400px"
												placement="right">
									<div class="box">
										<span class="box flex-center color-danger font-default pad-lr-xs">*</span>
										<efly-input size="default" type="password" width="100%" prefix-icon="icon-lock" placeholder="确认密码"
													v-model="status.confirmPassword" @blur="checkInput('confirmPassword')"></efly-input>
									</div>
								</efly-tooltip>
							</div>
							<!--<div class="popup-item">
								<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.trueName"
												:trigger="errorMsg.trueName ? 'show' : 'hide'" type="danger"
												position="absolute" top="2px" left="366px"
												placement="right">
									<div class="box">
										<span class="box flex-center color-danger font-default pad-lr-xs">*</span>
										<efly-input size="default" type="text" width="100%" prefix-icon="icon-trueName2" placeholder="真实姓名"
													v-model="status.trueName" @blur="checkInput('trueName')"></efly-input>
									</div>
								</efly-tooltip>
							</div>
							<div class="popup-item">
								<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.idNumber"
												:trigger="errorMsg.idNumber ? 'show' : 'hide'" type="danger"
												position="absolute" top="2px" left="366px"
												placement="right">
									<div class="box">
										<span class="box flex-center color-danger font-default pad-lr-xs">*</span>
										<efly-input size="default" type="text" width="100%" prefix-icon="icon-ID" placeholder="身份证号码"
													v-model="status.idNumber" @blur="checkInput('idNumber')"></efly-input>
									</div>
								</efly-tooltip>
							</div>-->
							<div class="popup-item">
								<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.phone"
												:trigger="errorMsg.phone ? 'show' : 'hide'" type="danger"
												position="absolute" top="-1px" left="400px"
												placement="right">
									<div class="box">
										<span class="box flex-center color-danger font-default pad-lr-xs">*</span>
										<efly-input size="default" type="text" width="100%" prefix-icon="icon-phone-number" placeholder="手机号码"
													v-model="status.phone" @keyup="checkInput('phone')"></efly-input>
									</div>
								</efly-tooltip>
							</div>
							<div class="popup-item">
								<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.vscode"
											:trigger="errorMsg.vscode ? 'show' : 'hide'" type="danger"
											position="absolute" top="-1px" left="400px"
											placement="right">
									<div class="box" style="justify-content:space-between;">
										<span class="box flex-center color-danger font-default pad-lr-xs">*</span>
										<efly-input size="default" style="margin-left: -9px;" type="text" width="228px" prefix-icon="icon-phoneCode" placeholder="请输入验证码"
													v-model="status.vscode" @blur="checkInput('vscode')" autocomplete="off"></efly-input>
										<div class="vscode cursor-pointer mar-l-mini">
											<efly-button style="width:130px;" class="btn-primary" @click="getPhoneCode()" v-if="loading.vscode === ''">获取验证码</efly-button>
											<efly-button style="width:130px;" class="btn-primary" v-if="loading.vscode === 'loading'">发送中...</efly-button>
											<efly-button style="width:130px;" class="btn-primary" :disabled="true" v-if="loading.vscode === 'havedata'">重新发送({{status.countDown}}s)</efly-button>
										</div>
									</div>
								</efly-tooltip>
							</div>
							<!--<div class="popup-item">
								<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.address"
												:trigger="errorMsg.address ? 'show' : 'hide'" type="danger"
												position="absolute" top="2px" left="366px"
												placement="right">
									<div class="box">
										<span class="box flex-center color-danger font-default pad-lr-xs">*</span>
										<efly-input size="default" type="text" width="100%" prefix-icon="icon-address" placeholder="通信地址"
													v-model="status.address" @blur="checkInput('address')"></efly-input>
									</div>
								</efly-tooltip>
							</div>
							<div class="popup-item">
								<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.zipCode"
												:trigger="errorMsg.zipCode ? 'show' : 'hide'" type="danger"
												position="absolute" top="2px" left="366px"
												placement="right">
									<div class="box">
										<span class="box flex-center color-danger font-default pad-lr-xs">*</span>
										<efly-input size="default" type="text" width="100%" prefix-icon="icon-zipCode" placeholder="邮政编码"
													v-model="status.zipCode" @blur="checkInput('zipCode')"></efly-input>
									</div>
								</efly-tooltip>
							</div>-->
						</div>
						<!--<div class="account-info-module account-new-module" style="margin-left:40px;">
							<div class="popup-item">
								<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;"
												:trigger="errorMsg.password ? 'show' : 'hide'" type="danger"
												position="absolute" :top="errorMsg.password.length > 19 ? '-5px' : '2px'" left="366px"
												placement="right">
									<div slot="content">
										<p class="break-wrod">{{errorMsg.password.slice(0, 19)}}</p>
										<p class="break-wrod" v-if="errorMsg.password.length > 19">{{errorMsg.password.slice(19)}}</p>
									</div>
									<div class="box">
										<span class="box flex-center color-danger font-default pad-lr-xs">*</span>
										<efly-input size="default" type="password" width="100%" prefix-icon="icon-lock" placeholder="注册密码(8~个32字符)"
													v-model="status.password" @blur="checkInput('password')"></efly-input>
									</div>
								</efly-tooltip>
							</div>

							<div class="popup-item">
								<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.confirmPassword"
												:trigger="errorMsg.confirmPassword ? 'show' : 'hide'" type="danger"
												position="absolute" top="2px" left="366px"
												placement="right">
									<div class="box">
										<span class="box flex-center color-danger font-default pad-lr-xs">*</span>
										<efly-input size="default" type="password" width="100%" prefix-icon="icon-lock" placeholder="确认密码(8~个32字符)"
													v-model="status.confirmPassword" @blur="checkInput('confirmPassword')"></efly-input>
									</div>
								</efly-tooltip>
							</div>
							<div class="popup-item">
								<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.emergencyContactName"
												:trigger="errorMsg.emergencyContactName ? 'show' : 'hide'" type="danger"
												position="absolute" top="2px" left="366px"
												placement="right">
									<div class="box">
										<span class="box flex-center color-danger font-default pad-lr-xs">*</span>
										<efly-input size="default" type="text" width="100%" prefix-icon="icon-emergencyContact" placeholder="紧急联系人姓名"
													v-model="status.emergencyContactName" @blur="checkInput('emergencyContactName')"></efly-input>
									</div>
								</efly-tooltip>
							</div>
							<div class="popup-item">
								<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.emergencyContactPhone"
												:trigger="errorMsg.emergencyContactPhone ? 'show' : 'hide'" type="danger"
												position="absolute" top="2px" left="366px"
												placement="right">
									<div class="box">
										<span class="box flex-center color-danger font-default pad-lr-xs">*</span>
										<efly-input size="default" type="text" width="100%" prefix-icon="icon-phone2" placeholder="紧急联系人电话"
													v-model="status.emergencyContactPhone" @blur="checkInput('emergencyContactPhone')"></efly-input>
									</div>
								</efly-tooltip>
							</div>
							<div class="popup-item">
								<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.emergencyContactAddress"
												:trigger="errorMsg.emergencyContactAddress ? 'show' : 'hide'" type="danger"
												position="absolute" top="2px" left="366px"
												placement="right">
									<div class="box">
										<span class="box flex-center color-danger font-default pad-lr-xs">*</span>
										<efly-input size="default" type="text" width="100%" prefix-icon="icon-address" placeholder="紧急联系人地址"
													v-model="status.emergencyContactAddress" @blur="checkInput('emergencyContactAddress')"></efly-input>
									</div>
								</efly-tooltip>
							</div>
							<div class="popup-item">
								<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.secretKey"
												:trigger="errorMsg.secretKey ? 'show' : 'hide'" type="danger"
												position="absolute" top="2px" left="366px"
												placement="right">
									<div class="box">
										<efly-input style="margin-left:17px;" size="default" type="text" width="100%" prefix-icon="icon-secretKey2" placeholder="密钥"
													v-model="status.secretKey" @blur="checkInput('secretKey')"></efly-input>
									</div>
								</efly-tooltip>
							</div>
							<div class="popup-item">
								<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.firstVisit"
												:trigger="errorMsg.firstVisit ? 'show' : 'hide'" type="danger"
												position="absolute" top="2px" left="366px"
												placement="right">
									<div class="box">
										<efly-input style="margin-left:17px;" size="default" type="text" width="100%" prefix-icon="icon-firstVisit" placeholder="首次访问该网站主页的地址"
													v-model="status.firstVisit" @blur="checkInput('firstVisit')"></efly-input>
									</div>
								</efly-tooltip>
							</div>
						</div>-->
					</div>

					<!--<div class="login-box-item">
						<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.vscode"
										:trigger="errorMsg.vscode ? 'show' : 'hide'" type="danger"
										position="absolute" top="2px" left="366px"
										placement="right">
							<div class="box">
								<efly-input size="default" type="text" width="60%" prefix-icon="icon-key" placeholder="请输入验证码"
											v-model="status.vscode" @blur="checkInput('vscode')"></efly-input>
								<div class="vscode cursor-pointer" @click="changeVscode()">
									<efly-button size="small" class="btn-outline-primary">获取短信验证码</efly-button>
								</div>
							</div>
						</efly-tooltip>
					</div>-->
					<div class="login-agree-item" style="width:388px;">
						<efly-tooltip class="box flex-column" style="width: 100%;text-align:left;" :content="errorMsg.iSelected"
										:trigger="errorMsg.iSelected ? 'show' : 'hide'" type="danger"
										position="absolute" top="-1px" left="400px"
										placement="right">
							<div class="login-agree-item">
								<div class="mar-b-xs box flex-justify-center">
									<efly-checkbox :active="iSelected" @click="changeCheckbox()"></efly-checkbox>
									<div class="box">同意</div> <div class="font-color" @click="getFile('user')">《用户服务协议》</div><div class="font-color" @click="getFile('privacy')">《安全隐私条款》</div>
								</div>
								<div class="box flex-justify-center">
									<div class="font-color" @click="getFile('network')">《网络信息安全承诺书》</div>
									<div class="font-color" @click="getFile('software')">《软件版权责任承担承诺书》</div>
								</div>

							</div>
						</efly-tooltip>
					</div>
					<div class="login-box-item mar-t-default" style="width:388px;padding-left:17px;">
						<efly-button size="default" class="btn-primary" style="width: 100%;padding-left:17px;" @click="submit()" v-show="status.loading !== 'loading'">注&nbsp;&nbsp;&nbsp;&nbsp;册</efly-button>
						<efly-button size="default" class="btn-primary" style="width: 100%;" v-show="status.loading === 'loading'"><img src="../../../../common/src/assets/image/login-loading.gif" alt=""></efly-button>
					</div>
				</div>

				<login-footer :type="'ecp'"></login-footer>
			</div>
		</div>

		<sliding-verification-code :show="component.code" :phone="status.phone" type="register" @success="vscodeChange()"></sliding-verification-code>
	</div>
</template>

<script>
    import Login from "./register";

    export default Login;
</script>
<style lang="scss">
	.login-box-item {
		.efly-input,input,.efly-button {
			border-radius: 3px;
			height: 44px;
		}
		.efly-input .icon {
			color: #BDBDBD;
			font-size: 14px;
		}
		.efly-input input{
			color: #555;
		}
		.efly-button {
			font-size: 18px;
		}
	}
</style>
<style lang="scss" scoped>
.login-container {
	width: 100%;
	height: 100%;
	min-width: 1200px;
	box-sizing: border-box;
	* {box-sizing: border-box;}

	.login-container-bg {
		width: 100%;
		height: 100%;
		background: url('../../assets/image/login-bg.png') no-repeat;
		background-color: #EBF2FA;
		position: relative;

		.login-content {
			width: 100%;
			height: 100%;
			text-align: center;
			// background: url('../../assets/image/login-box.png') top center no-repeat;
			// background-size: 1800px;
			.popup-container {
				padding: 20px 20px 0 20px;
			}
			.login-logo {
				padding-top: 100px;
				text-align: center;
			}

			.login-box {
				width: 1030px;
				height: 600px;
				margin: auto;
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				background: url('../../assets/image/register-box.png') 107% 110% no-repeat;
				background-color: #fff;
				box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.12);
				text-align: center;

				.register-box-item-title {
					display: flex;
					justify-content: space-between;
					line-height: 50px;
					box-sizing: border-box;
					border-bottom: 1px solid #DCDCDC;
					margin-bottom: 40px;

					.register-box-title {
						margin: 0;
						font-size: 20px;
					}
				}
				.login-agree-item {
					margin: 0 auto;
					.flex-justify-center {
						justify-content: center;
					}
					.font-color {
						color: #009FEF;
						cursor: pointer;
					}
				}
				.login-box-item {
					width: 358px;
					margin: auto;
					margin-bottom: 60px;
					.vscode {
						width: 40%;
						margin-left: 5px;
						img {
							width: 100%;
							height: 100%;
						}
						button {
							font-size: 14px;
							width: 100%;
							background: #E8F6FF;
							&:hover {
								color: #009FEF !important;
								opacity: 0.9;
							}
						}
					}
				}

				.popup-info-container {
					display: flex !important;
					justify-content: center;
					.account-info-module {
						width: 40%;
						.popup-item {
							.popup-item-label {
								min-width: 90px;
							}
						}
					}
				}
			}
		}
	}
}
.break-wrod {
	word-wrap: break-word;
}
</style>
